module.exports = __webpack_public_path__ + "img/Jonas-Fjeld_Illustrasjonen-under-Skillingsviser-er-på-kanten.9892b381.jpg";